import React from "react";

import { LogContextProvider } from "src/features/forms/context/LogContext";
import { FormState } from "src/features/forms/types";

export const FormContext = React.createContext<FormState>({
	isInitialized: false,
	value: {},
	setValue() {
		return Promise.resolve();
	},
	messages: [],
	warnings: [],
	errors: []
});

export const FormContextProvider: React.FunctionComponent<
	React.PropsWithChildren<FormState>
> = React.memo(({ children, ...ctx }) => (
	<FormContext.Provider value={ctx}>
		<LogContextProvider>{children}</LogContextProvider>
	</FormContext.Provider>
));
